<div class="partial-payment">
  <form #PartialForm="ngForm" (ngSubmit)="save(true)">

    <div class="field-row">
      <div class="field">
        <label>Pay Method</label>
        <rms-select name="PaymentDetailTypeID"
                    [options]="Methods"
                    labelKey="DetailTypeName"
                    valueKey="PaymentDetailTypeID"
                    placeholder="Select Pay Method…"
                    [required]="true"
                    [(ngModel)]="PaymentDetailTypeID">
        </rms-select>
      </div>
      <div class="field">
        <label>Bank</label>
        <rms-select name="BankID"
                    [options]="Banks"
                    labelKey="BankName"
                    valueKey="BankID"
                    [required]="true"
                    [(ngModel)]="BankID">
        </rms-select>
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label>Amount</label>
        <rms-input name="Amount" type="currency" [required]="true" [(ngModel)]="Amount"></rms-input>
        @if (amountError) {
        <span class="field-error">{{ amountError }}</span>
        } @else {
        <span class="field-hint">Left on this order: {{ LeftToProcess | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
        }
      </div>
      <div class="field">
        <label>Deposit Date</label>
        <rms-date name="DepositDate" label="" [required]="true" [(ngModel)]="DepositDate"></rms-date>
        <span class="field-hint">Used when posting</span>
      </div>
    </div>

    @if (Error) {
    <div class="save-error">{{ Error }}</div>
    }

    <div class="actions">
      <button class="btn-bg-slate" type="button" [disabled]="Saving" (click)="cancel()">Cancel</button>
      <button class="btn-bg-yellow" type="button" [disabled]="!isValid || Saving" (click)="save(false)"
              title="Record it as Processing and post it later with the row's Post button">
        Process only
      </button>
      <button class="btn-bg-green" type="submit" [disabled]="!isValid || Saving">
        {{ Saving ? 'Saving…' : 'Post Payment' }}
      </button>
    </div>

  </form>
</div>
